import styled from "styled-components";

export const SignupWrapper = styled.div``